import React from "react";
import { connect } from "react-redux";
import { ProjectAddressApi, ProjectMemberApi } from "../../../../api";
import axios from "axios";
import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
} from "antd";
import { H6 } from "../../../../AbstractElements";
import { PlusOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import moment from "moment";

function DeliveryDrawer(props) {
  const [members, setMembers] = React.useState([]);
  const [form] = Form.useForm();
  const [billAddress, setBillAddress] = React.useState(null);
  const [shipAddress, setShipAddress] = React.useState(null);
  const [billToDisplayAddress, setBillToDisplayAddress] = React.useState();
  const [shipToDisplayAddress, setShipToDisplayAddress] = React.useState();
  const [projectAddress, setProjectAddress] = React.useState([]);
  const [visibleAddress, setVisibleAddress] = React.useState(false);

  const formRefAddress = React.useRef(null);

  const fetchAddress = (params = {}) => {
    axios.get(`${ProjectAddressApi}`, { params: { ...params } }).then((res) => {
      setProjectAddress(res.data);
    });
  };

  const addNewAddress = React.useCallback(
    (updatedValues) => {
      const values = new FormData();
      values.append("label", updatedValues.label);
      values.append("city", updatedValues.city);
      values.append("pincode", updatedValues.pincode);
      values.append("address", updatedValues.address);
      values.append("project", props.settings?.project?.id);
      values.append("contact_person", updatedValues.contact_person);
      values.append("contact_phone", updatedValues.contact_phone);
      values.append("contact_email", updatedValues.contact_email);
      values.append("google_map_address", updatedValues.google_map_address);
      values.append("gst_no", updatedValues.gst_no);
      values.append("pan_no", updatedValues.pan_no);
      axios
        .post(`${ProjectAddressApi}`, values)
        .then((res) => {
          toast.success("Successfully added address!");
          fetchAddress({ project: props.settings?.project?.id });
          onCloseAddress();
        })
        .catch(() => {
          toast.error("Something went wrong!");
        });
    },
    [props.settings?.project?.id]
  );

  const onCloseAddress = () => {
    formRefAddress.current.resetFields();
    setVisibleAddress(false);
  };

  const fetchMembers = (params = {}) => {
    axios.get(`${ProjectMemberApi}`, { params: { ...params } }).then((res) => {
      setMembers(res.data);
    });
  };

  React.useEffect(() => {
    fetchMembers({ project: props.settings?.project?.id });
    fetchAddress({ project: props.settings?.project?.id });
  }, [props?.settings?.project?.id]);

  React.useEffect(() => {
    form?.setFieldsValue({
      ...props.deliveryDetails,
      delivery_poc: props.deliveryDetails?.delivery_poc?.id,
      expected_delivery_time : moment(props.deliveryDetails?.expected_delivery_time)
    });
  }, [props.deliveryDetails, form]);

  const onSubmit = (values) => {
    // Convert moment object to Django DateTimeField
    values.expected_delivery_time =
      values.expected_delivery_time.format("YYYY-MM-DD");

    if (!shipAddress) {
      toast.error("Please select a shipping address!");
      return;
    }

    const fields = {
      ...values,
      bill_address: billAddress,
      ship_address: shipAddress,
    };
    props.onFinish(fields);
  };
  const showDrawerAddress = React.useCallback(() => {
    setVisibleAddress(true);
  }, []);

  const shippingAddress = React.useMemo(
    () => (
      <div
        style={{
          padding: "1rem",
          border: "1px solid #ccc",
          borderRadius: 5,
          marginBottom: 14,
        }}
      >
        <Row justify="space-between">
          <H6>Ship To</H6>
        </Row>
        <Row gutter={16} className="mt-3">
          <Col sm={6} md={6}>
            Name
          </Col>
          <Col sm={18} md={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>{shipToDisplayAddress?.label ?? ""}</Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={16} className="mt-3">
          <Col sm={6} md={6}>
            Address
          </Col>
          <Col sm={18} md={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>
                {/* <Form.Item name="ship_address"> */}
                <Select
                  className="w-100"
                  key={"ship_address_select"}
                  value={shipAddress}
                  optionFilterProp="children"
                  placeholder={"Address"}
                  onChange={(e) => {
                    console.log(" e ", e);
                    setShipAddress(e);
                    setShipToDisplayAddress(
                      projectAddress.find((addr) => addr.id === e)
                    );
                  }}
                >
                  {projectAddress?.map((each) => {
                    return (
                      <Select.Option key={each.id} value={each.id}>
                        {each?.label}
                      </Select.Option>
                    );
                  })}
                </Select>
                {/* </Form.Item> */}
              </Col>
              <Col>
                <Button
                  style={{ marginLeft: "10px" }}
                  icon={<PlusOutlined />}
                  onClick={() => {
                    showDrawerAddress();
                  }}
                >
                  Add New Address
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row gutter={16} className="mt-2">
          <Col sm={6} md={6}>
            Contact person
          </Col>
          <Col sm={18} md={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>{shipToDisplayAddress?.contact_person}</Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col sm={6} md={6}>
            Contact number
          </Col>
          <Col sm={18} md={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>{shipToDisplayAddress?.contact_phone}</Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={16} className="mt-1">
          <Col sm={18} md={18}>
            {shipToDisplayAddress && (
              <Row className="mt-1">
                Selected address: {shipToDisplayAddress?.address},{" "}
                {shipToDisplayAddress?.city} {shipToDisplayAddress?.pincode}
              </Row>
            )}
          </Col>
        </Row>

        <Row gutter={16} className="mt-3">
          <Col sm={6} md={6}>
            Google Maps Address
          </Col>
          <Col sm={18} md={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>{shipToDisplayAddress?.google_map_address}</Col>
            </Row>
          </Col>
        </Row>
      </div>
    ),
    [projectAddress, shipToDisplayAddress, shipAddress, showDrawerAddress]
  );

  const billingAddress = React.useMemo(
    () => (
      <div
        style={{ padding: ".5rem", border: "1px solid #ccc", borderRadius: 5 }}
      >
        <Row justify="space-between">
          <H6>Bill To</H6>
        </Row>
        <Row gutter={16} className="mt-3">
          <Col sm={6} md={6}>
            Name
          </Col>
          <Col sm={18} md={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>{billToDisplayAddress?.label ?? ""}</Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={16} className="mt-3">
          <Col sm={6} md={6}>
            Address
          </Col>
          <Col sm={18} md={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>
                {/* <Form.Item name="bill_address"> */}
                <Select
                  className="w-100"
                  key={"bill_address_select"}
                  value={billAddress}
                  optionFilterProp="children"
                  placeholder={"Address"}
                  onChange={(e) => {
                    setBillAddress(e);
                    setBillToDisplayAddress(
                      projectAddress.find((addr) => addr.id === e)
                    );
                  }}
                >
                  {projectAddress?.map((each) => {
                    return (
                      <Select.Option key={each.id} value={each.id}>
                        {each?.label}
                      </Select.Option>
                    );
                  })}
                </Select>
                {/* </Form.Item> */}
              </Col>
              <Col>
                <Button
                  style={{ marginLeft: "10px" }}
                  icon={<PlusOutlined />}
                  onClick={() => {
                    showDrawerAddress();
                  }}
                >
                  Add New Address
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row gutter={16} className="mt-2">
          <Col sm={6} md={6}>
            Contact person
          </Col>
          <Col sm={18} md={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>{billToDisplayAddress?.contact_person}</Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col sm={6} md={6}>
            Contact number
          </Col>
          <Col sm={18} md={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>{billToDisplayAddress?.contact_phone}</Col>
            </Row>
          </Col>
        </Row>

        <Row gutter={16} className="mt-1">
          <Col sm={18} md={18}>
            {billToDisplayAddress && (
              <Row className="mt-1">
                Selected address: {billToDisplayAddress?.address},{" "}
                {billToDisplayAddress?.city} {billToDisplayAddress?.pincode}
              </Row>
            )}
          </Col>
        </Row>

        <Row gutter={16} className="mt-3">
          <Col sm={6} md={6}>
            Google Maps Address
          </Col>
          <Col sm={18} md={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>{billToDisplayAddress?.google_map_address}</Col>
            </Row>
          </Col>
        </Row>
      </div>
    ),
    [billAddress, billToDisplayAddress, projectAddress, showDrawerAddress]
  );

  return (
    <>
      <Drawer
        title="Delivery details"
        placement="right"
        closable={true}
        onClose={() => props.onClose(true)}
        visible={props.visible}
        width={600}
        footer={
          <Space>
            <Button onClick={() => props.onClose(true)}>Cancel</Button>
            <Button type="primary" onClick={form?.submit}>
              Save
            </Button>
          </Space>
        }
      >
        <Form layout="vertical" onFinish={onSubmit} form={form}>
          {/* <Form.Item
            label="Delivery POC"
            name="delivery_poc"
            rules={[{ required: true }]}
          >
            <Select>
              {members.map((member) => (
                <Select.Option value={member?.user_organisation?.user?.id}>
                  {member?.user_organisation?.user?.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="delivery_location"
            label="Delivery Location"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item> */}
          <Form.Item
            name="expected_delivery_time"
            label="Expected Delivery Time"
            rules={[{ required: true }]}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item name="remarks" label="Remarks">
            <Input.TextArea />
          </Form.Item>
        </Form>
        {shippingAddress}
        {billingAddress}
      </Drawer>
      <Drawer
        title={"Add Address"}
        width={500}
        onClose={() => {
          onCloseAddress();
        }}
        visible={visibleAddress}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button
              onClick={() => {
                onCloseAddress();
              }}
              style={{ marginRight: 8 }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              form="addressForm"
              type="primary"
              onClick={() => formRefAddress?.current?.submit()}
            >
              Submit
            </Button>
          </div>
        }
      >
        <Form
          layout="vertical"
          id="addressForm"
          ref={formRefAddress}
          onFinish={addNewAddress}
        >
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"label"}
                label="Label"
                rules={[
                  {
                    required: true,
                    message: "Label is required",
                  },
                ]}
              >
                <Input placeholder="e.g. Bangalore Address" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={24}>
              <Form.Item
                name={"address"}
                label="Address"
                rules={[
                  {
                    required: true,
                    message: "Address is required",
                  },
                ]}
              >
                <Input.TextArea
                  autoSize={{
                    minRows: 3,
                    maxRows: 20,
                  }}
                  placeholder="e.g. Bangalore Address"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"city"}
                label="City"
                rules={[
                  {
                    required: true,
                    message: "City is required",
                  },
                ]}
              >
                <Input placeholder="City" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"pincode"}
                label="Pincode"
                rules={[
                  {
                    required: true,
                    message: "Pincode is required",
                  },
                ]}
              >
                <Input
                  showCount
                  maxLength={6}
                  minLength={6}
                  placeholder="Pincode"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name="contact_person"
                label="Contact Person"
                rules={[
                  {
                    required: true,
                    message: "Contact Person is required",
                  },
                ]}
              >
                <Input placeholder="Contact Person" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"contact_phone"}
                label="Contact Phone"
                rules={[
                  {
                    required: true,
                    message: "Contact Phone is required",
                  },
                ]}
              >
                <Input placeholder="Contact Phone" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"contact_email"}
                label="Contact Email"
                rules={[
                  {
                    required: true,
                    message: "Contact Email is required",
                  },
                ]}
              >
                <Input placeholder="Contact Email" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name="google_map_address"
                label="Google Map Address"
                rules={[
                  {
                    type: "url",
                    message: "Please enter a valid URL",
                  },
                ]}
              >
                <Input placeholder="Google Map Address" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"gst_no"} label="GST No">
                {/* After user finishes typing try to parse and set the pan no */}
                <Input
                  placeholder="GST No"
                  onBlur={(e) => {
                    const gst = e.target.value;
                    if (gst.length === 15) {
                      const pan = gst.slice(2, 12);
                      formRefAddress.current?.setFieldsValue({
                        pan_no: pan,
                      });
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"pan_no"} label="PAN No">
                <Input placeholder="PAN No" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
}

const mapStateToProps = ({ dispatch, settings }) => {
  return {
    dispatch,
    settings,
  };
};

export default connect(mapStateToProps)(DeliveryDrawer);
